import React, {Component, PropTypes} from 'react';
import {DragSource} from 'react-dnd';
import {api} from "../rest";
import swal from "sweetalert2";
import LoadingStore from "../stores/LoadingStore";
import moment from "moment";
import ServicesStore from "../stores/ServicesStore";
import flyingAirship from "../aircraft.svg";
import landingAirship from "../aircraft-landing.svg";
import takeOffAirship from "../aircraft-take-off.svg";


const weekDaySource = {
	beginDrag(props) {
		return props.move;
	},
	endDrag(props, monitor) {
		const item = monitor.getItem();
		const dropResult = monitor.getDropResult();
		if (dropResult) {
			let data = ServicesStore.getServiceById(item.id);
			if (item.render === 1) {
				//covers a single move goes and comes
				let data = ServicesStore.getServiceById(item.id);
				data.bus_id = dropResult.busId;
				data.salida = data.salida.split(" ").map((c, i)=>i == 0 ? dropResult.date : c).join(" ");
				data.regreso = data.regreso.split(" ").map((c, i)=>i == 0 ? dropResult.date : c).join(" ");
			} else {
				//covers more than a day so move all the dates delta date
				let deltaDate = moment(item.date).diff(moment(dropResult.date), "days");
				data.bus_id = dropResult.busId;
				data.salida = moment(data.salida).add(-deltaDate, "day").format("YYYY-MM-DD HH:mm");
				data.regreso = moment(data.regreso).add(-deltaDate, "day").format("YYYY-MM-DD HH:mm");
			}
			LoadingStore.startLoading();
			api.patch(`buses/${dropResult.busId}/services/${item.id}`, data)
				.catch((error)=> {
					if (error.response && error.response.status === 406) {
						//http://stackoverflow.com/questions/24816/escaping-html-strings-with-jquery
						const info = error.response.data.map(({salida, regreso, destino})=> {
							const scapedDestino = destino.replace(/[\"&<>]/g, function (a) {
								return {'"': '&quot;', '&': '&amp;', '<': '&lt;', '>': '&gt;'}[a];
							});
							return `<li>${scapedDestino}:<br/>${salida} &rarr; ${regreso}</li>`
						}).reduce((info)=>info);
						swal("Conflictos", `<ul>${info}</ul>`, "info");
					} else {
						swal("Error", error.message, "error");
					}
					console.error(error);
					LoadingStore.stopLoading();
				});
		}
	}
};

function collect(connect, monitor) {
	return {
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging()
	}
}

class WeekDayDraggable extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			color: this.context.getColor(this.props.move.contractor_id)
		};
		this.updateColor = this.updateColor.bind(this);
	}

	updateColor () {
		let color = this.context.getColor(this.props.move.contractor_id);
		this.setState({color})
	}

	componentWillMount() {
		LoadingStore.on("reload-colors",this.updateColor)
	}

	componentWillUnmount() {
		LoadingStore.removeListener("reload-colors",this.updateColor)
	}


	render() {
		const WeekDayElement = (props) => {
			const MAX_LENGTH = 15;
			let isMoreThanMaxLength = props.destino.length > MAX_LENGTH;
			const limitedContent = isMoreThanMaxLength ? `${props.destino.slice(0, MAX_LENGTH)}...` : props.destino;

			let unique = props.render === -1 ? (
				<img className="unique-move-day-info" src={flyingAirship}/>
			) : null;

			let takeOff = props.render === 1 || props.render === 2 ? (
					<img className="move-day-exit" src={takeOffAirship}/>
			) : null;

			let landing = props.render === 1 || props.render === 0 ? (
				<img className="move-day-enter" src={landingAirship}/>
			) : null;

			let style = {
				cursor: "pointer"
			};

			if (props.render === -1) {
				return (
					<div style={style} title={isMoreThanMaxLength ? props.destino : ""}>
						{unique}
						<br/>
						{limitedContent}
					</div>
				);
			} else {
				return (
					<div style={style} title={isMoreThanMaxLength ? props.destino : ""}>
						{takeOff} {limitedContent} {landing}
					</div>
				);
			}
		};
		const {connectDragSource, isDragging} = this.props;

		let style = {
			opacity: isDragging ? 0.5 : 1,
			cursor: 'move'
		};

		if (this.state.color) {
			style.border =  "2px dashed "+this.state.color;
		}
		return connectDragSource(
			<div className="week-day-move" style={style}>
				<WeekDayElement {...this.props.move}/>
			</div>
		);
	}
}

WeekDayDraggable.propTypes = {
	connectDragSource: PropTypes.func.isRequired,
	isDragging: PropTypes.bool.isRequired
};

WeekDayDraggable.contextTypes = {
	getColor: PropTypes.func.isRequired
};

export default DragSource("week_day", weekDaySource, collect)(WeekDayDraggable);


/** WEBPACK FOOTER **
 ** ./src/components/week_day_draggable.js
 **/